import React from 'react';

import styles from './requestUpdateModalStyles';

import Modal from 'buyside/components/presentation/Modal/modal';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

class RequestUpdateModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalOpen: false,
      body: '',
      error: '',
      loading: false,
      complete: false
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBodyChange = this.handleBodyChange.bind(this);
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  handleBodyChange(e) {
    this.setState({ body: e.currentTarget.value });
  }

  handleSubmit() {
    const { body } = this.state;
    const { requestIdeaUpdate, ideaId } = this.props;
    if (!body) {
      this.setState({ error: "Message can't be blank" });
    } else {
      this.setState({ error: '', loading: true });
      requestIdeaUpdate({
        body,
        ideaId
      }).then(
        () => {
          this.setState({ loading: false, body: '', complete: true });
        },
        () => {
          this.setState({
            loading: false,
            error:
              'There was an error sending your idea update request. Please try again or contact support@sumzero.com.'
          });
        }
      );
    }
  }

  renderOpenModalButton(buttonOptions) {
    return (
      <Button
        {...buttonOptions}
        onClick={() => this.setState({ modalOpen: true, complete: false })}
      />
    );
  }

  render() {
    const { loading, body, error, complete } = this.state;
    const { buttonOptions, receiverName } = this.props;

    return (
      <div>
        <Modal
          isOpen={this.state.modalOpen}
          onClose={this.closeModal}
          renderOpenModalButton={() => this.renderOpenModalButton(buttonOptions)}
          title={complete ? 'Update Request Sent' : `Idea Update Request to ${receiverName}`}
        >
          {(!complete && (
            <div>
              <div>
                <div className={styles.labelItem}>
                  <label className={styles.bodyLabel}>
                    Please Describe What You Would Like to See Updated Below
                  </label>
                  <div className={styles.fullWidth}>
                    <textarea
                      className={styles.bodyInput}
                      disabled={loading}
                      onChange={this.handleBodyChange}
                      value={body}
                    />
                  </div>
                </div>
              </div>
              {error && <div className={styles.errorSection}>{error}</div>}
              <div className={styles.buttonArea}>
                <Button
                  text="Send Request"
                  type={BUTTON_TYPES.PRIMARY}
                  onClick={this.handleSubmit}
                  isLoading={loading}
                />
                <Button text="Cancel" onClick={this.closeModal} />
              </div>
            </div>
          )) || (
            <div>
              <div className={styles.successText}>Your update request was sent sucessfully.</div>
              <Button text="OK" onClick={this.closeModal} type={BUTTON_TYPES.PRIMARY} />
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

export default RequestUpdateModal;
